exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-guide_video-box_1IyPW {\n    padding:5px;\n}\n.video-guide_video-container_17t0X [class*=body] {\n    position: relative;\n}\n.video-guide_video-container_17t0X [class*=body],.video-guide_box_3fScX,.video-guide_video-box_1IyPW {\n    width:100%;\n    height:100%;\n}\n.video-guide_videoGuideOverlay_9HNn7 {\n    background-color:rgba(0,0,0,.7);\n}\n/* .video-box video {\n\n} */\n.video-guide_video-container_17t0X {\n    width:80%;\n    height: 80%;\n    /* padding:0; */\n    border:0;\n    overflow: unset;\n\n    \n}\n.video-guide_video-container_17t0X [class*=close-button] {\n    position: absolute;\n    right:-22px;\n    top:-16px;\n    color:#fff;\n}", ""]);

// exports
exports.locals = {
	"video-box": "video-guide_video-box_1IyPW",
	"videoBox": "video-guide_video-box_1IyPW",
	"video-container": "video-guide_video-container_17t0X",
	"videoContainer": "video-guide_video-container_17t0X",
	"box": "video-guide_box_3fScX",
	"videoGuideOverlay": "video-guide_videoGuideOverlay_9HNn7"
};